import { connect } from 'fluent'
import * as React from 'react'

import { Image, Loader, Root } from './elements'

interface Props {
  src: string
  className?: string

  height?: number
  width?: number
  maxWidth?: number
  maxHeight?: number
}

interface State {
  type: 'loading' | 'loaded' | 'error'
  height?: number
  width?: number
}

/**
 * Expandable image
 */
const ExpandableImage = connect<Props>()
  .with(({ state, signals, props }) => ({
    toggle: signals.modal
  }))
  .toClass(
    props =>
      class ExpandableImage extends React.PureComponent<typeof props, State> {
        state: State = {
          type: 'loading'
        }

        open() {
          const { src, toggle } = this.props
          if (src) {
            toggle({
              open: true,
              type: 'image',
              data: src
            })
          }
        }

        render() {
          const {
            className,
            height,
            width,
            maxHeight,
            maxWidth,
            src
          } = this.props
          const imageHeight = height || this.state.height
          const imageWidth = width || this.state.width

          return (
            <Root
              className={className || null}
              onClick={this.open.bind(this)}
              maxHeight={maxHeight}
              maxWidth={maxWidth}
              height={imageHeight}
              width={imageWidth}
            >
              <Image
                src={src}
                onLoad={({ currentTarget }) =>
                  this.setState({
                    type: 'loaded',
                    height: currentTarget.naturalHeight,
                    width: currentTarget.naturalWidth
                  })
                }
                onError={() => this.setState({ type: 'error' })}
              />
              {this.state.type === 'loading' && <Loader />}
            </Root>
          )
        }
      }
  )

export default ExpandableImage



// WEBPACK FOOTER //
// ./src/modules/styled-elements/ExpandableImage/index.tsx